import React from 'react'
import styled from 'styled-components'

const ContentContainer = styled.div`
  font-size: 16px;
  line-height: 24px;
  @media (max-width: 959px) {
    padding: 0 30px;
  }

  h2,
  h3 {
    font-weight: bold;
  }

  h2 {
    @media (min-width: 960px) {
      font-size: 48px;
      line-height: 62px;
    }
  }

  h3 {
    font-size: 27px;

    @media (max-width: 959px) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  p {
    margin-bottom: 20px;
    @media (max-width: 959px) {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 40px;
    }
  }
`

const Content = ({ children }) => {
  return <ContentContainer>{children}</ContentContainer>
}

export default Content
